export const messages = {
  en: {
    layout: {
      home: 'Home',
      businessManagement: 'Business Management',
      propertyManagement: 'Property',
      userManagement: 'User',
      OAManagement: 'OA',
      parkingManagement: 'Parking',
      monitoringManagement: 'Monitoring',
      settingManagement: 'Settings',
      logout: 'Logout',
      machineManagement: 'Machine Management',
      tenantManagement: 'Tenant Management',
      systemManagement: 'System Management',
      menuGroup: 'Menu Group',
      machine: 'Machine',
      tenant: 'Tenant',
      project: 'Project',
      machineList: 'Machine List',
      machineAdd: 'Add Machine',
      machineEdit: 'Edit Machine',
      machineCode: 'Machine Code',
      machineName: 'Machine Name',
      machineIp: 'Machine IP',
      machineMac: 'Machine MAC',
      machineType: 'Machine Type',
      implBean: 'Manufacturer',
      heartbeatTime: 'Heartbeat Time',
      status: 'Status',
      inUse: 'In Use',
      invalid: 'Invalid',
      remark: 'Remark',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
      required: 'This field is required',
      addSuccess: 'Add success',
      editSuccess: 'Edit success',
      deleteSuccess: 'Delete success',
      deleteConfirm: 'Are you sure to delete this item?',
      tip: 'Tip',
      fetchError: 'Failed to fetch data',
      deleteError: 'Failed to delete',
      submitError: 'Failed to submit',
      moreCommunity:'More Community'
    }
  },
  zh: {
    layout: {
      home: '首页',
      businessManagement: '业务管理',
      propertyManagement: '物业管理',
      userManagement: '用户管理',
      OAManagement: 'OA管理',
      parkingManagement: '停车管理',
      monitoringManagement: '监控管理',
      settingManagement: '设置',
      logout: '退出',
      machineManagement: '设备管理',
      tenantManagement: '租户管理',
      systemManagement: '系统管理',
      machine: '设备',
      tenant: '租户',
      project: '项目',
      menuGroup: '菜单组',
      machineList: '设备列表',
      machineAdd: '添加设备',
      machineEdit: '编辑设备',
      machineCode: '设备编码',
      machineName: '设备名称',
      machineIp: '设备IP',
      machineMac: '设备MAC',
      machineType: '设备类型',
      implBean: '门禁厂家',
      heartbeatTime: '心跳时间',
      status: '状态',
      inUse: '在用',
      invalid: '失效',
      remark: '备注',
      operation: '操作',
      edit: '编辑',
      delete: '删除',
      cancel: '取消',
      confirm: '确定',
      required: '此字段为必填项',
      addSuccess: '添加成功',
      editSuccess: '编辑成功',
      deleteSuccess: '删除成功',
      deleteConfirm: '确定要删除此项吗？',
      tip: '提示',
      fetchError: '获取数据失败',
      deleteError: '删除失败',
      submitError: '提交失败',
      moreCommunity:'更多小区'
    }
  }
} 